const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  token: state => state.user.token,
  id: state => state.user.id,
  person: state => state.user.person,
  phone: state => state.user.phone,
  area: state => state.user.area,
  groupid: state => state.user.groupid,
  branchid: state => state.user.branchid,
  name: state => state.user.name,
  email: state => state.user.email,
  lastlogin: state => state.user.lastlogin,
  is_superuser: state => state.user.is_superuser,
  roles: state => state.user.roles,
  errorLogs: state => state.errorLog.logs,
  cartbeers: state => state.cart.beers,
  note: state => state.cart.note
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js